import { graphql } from "react-apollo";
import gql from "graphql-tag";

export const GET_DOCUMENT_VERIFICATION_STATUS = gql`
  query GetDocumentVerificationStatus($userId: String!) {
    getDocumentVerificationStatus(userId: $userId) {
      status
      message
      
    }
  }
`;

export const GET_DOCUMENT_VERIFICATION_START =
  "GET_DOCUMENT_VERIFICATION_START";
export const GET_DOCUMENT_VERIFICATION_SUCCESS =
  "GET_DOCUMENT_VERIFICATION_SUCCESS";
export const GET_DOCUMENT_VERIFICATION_ERROR =
  "GET_DOCUMENT_VERIFICATION_ERROR";

export const getDocumentVerificationStatus = (userId) => async (dispatch) => {
  dispatch({ type: GET_DOCUMENT_VERIFICATION_START });

  try {
    const response = await fetch("/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        query: `query GetDocumentVerificationStatus($userId: String!) {
    getDocumentVerificationStatus(userId: $userId) {
      status
      message
      
    }
  }`,
        variables: {
          userId: userId,
        },
      }),
    });

    const result = await response.json();
    const verificationData = result.data?.getDocumentVerificationStatus;

    // Log for debugging
    console.log("Document Verification Response:", verificationData);

    if (verificationData) {
      if (verificationData.status === "approved") {
        dispatch({
          type: GET_DOCUMENT_VERIFICATION_SUCCESS,
          payload: {
            status: verificationData.status,
            message: verificationData.message,
          },
        });
        return "accept";
      } else if (verificationData.status === "rejected") {
        dispatch({
          type: GET_DOCUMENT_VERIFICATION_ERROR,
          payload: {
            error: verificationData.message || "Document verification failed",
            status: verificationData.status,
          },
        });
        return "reject";
      } else if (
        verificationData.status === "pending" ||
        verificationData.status === "not_found"
      ) {
        // For pending or not_found, return null to continue polling
        return null;
      } else {
        dispatch({
          type: GET_DOCUMENT_VERIFICATION_ERROR,
          payload: {
            error: verificationData.message || "Unknown verification status",
            status: verificationData.status,
          },
        });
        return "pending";
      }
    }

    return null;
  } catch (error) {
    console.error("Error checking document verification status:", error);
    dispatch({
      type: GET_DOCUMENT_VERIFICATION_ERROR,
      payload: {
        error: error.message || "Failed to check document verification status",
      },
    });
    return "pending";
  }
};
